import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HostnameService } from 'app/services/hostname.service';

export const landingGuard: CanActivateFn = () => {
    const hostnameService = inject(HostnameService);
    const router = inject(Router);

    if (hostnameService.isLandingDomain()) {
        return true;
    }

    // In production on app.* domain, redirect / to /painel
    router.navigateByUrl('/painel');
    return false;
};
